import React from 'react';
import { CustomerData, InvoiceData, PaymentData } from '../types';

interface DataDisplayProps {
  data: CustomerData | InvoiceData | PaymentData | null;
  type: 'customer' | 'invoice' | 'payment';
}

const DataDisplay: React.FC<DataDisplayProps> = ({ data, type }) => {
  if (!data) return null;

  if (type === 'customer') {
    const customer = data as CustomerData;
    return (
      <div className="bg-gray-50 p-2 rounded border">
        <div>ID: {customer.id || 'N/A'}</div>
        <div>Name: {customer.first_name} {customer.last_name}</div>
        <div>Company: {customer.company_name || 'N/A'}</div>
        <div>QBO ID: {customer.customer_qbo_id || 'N/A'}</div>
      </div>
    );
  }

  if (type === 'invoice') {
    const invoice = data as InvoiceData;
    return (
      <div className="bg-gray-50 p-2 rounded border">
        <div>ID: {invoice.id || 'N/A'}</div>
        <div>Customer ID: {invoice.fk_bcustomer_id || 'N/A'}</div>
        <div>Amount: ${invoice.amount_due || 0}</div>
        <div>Status: {invoice.status?.label || 'N/A'}</div>
        <div>QBO ID: {invoice.invoice_qbo_id || 'N/A'}</div>
      </div>
    );
  }

  if (type === 'payment') {
    const payment = data as PaymentData;
    return (
      <div className="bg-gray-50 p-2 rounded border">
        <div>ID: {payment.payment_id || 'N/A'}</div>
        <div>Customer ID: {payment.fk_bcustomer_id || 'N/A'}</div>
        <div>Amount: ${payment.payment_amount || 0}</div>
        <div>Date: {payment.received_on || 'N/A'}</div>
        <div>QBO ID: {payment.payment_qbo_id || 'N/A'}</div>
      </div>
    );
  }

  return null;
};

export default DataDisplay;
